<template>
  <div>
    <div>
      <el-select v-model="queryByStatus" placeholder="请选择" @change="handleChangeStatus">
        <el-option
          v-for="n in stockStatus"
          :key="n.key"
          :label="n.label"
          :value="n.value">
        </el-option>
      </el-select>
    </div>
    <div class="comond_btn">
      <el-button  @click="handleEdit(0, null)" >添加仓储</el-button>
    </div>
    <template>
      <el-table
        :data="list"
        style="width: 100%">
        <el-table-column
          prop="locationName"
          label="库位详细地址"
          width="">
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态">
        </el-table-column>
        <el-table-column
          prop="companyName"
          label="所属公司">
        </el-table-column>
        <el-table-column
          prop="createBy"
          label="创建人">
        </el-table-column>
        <el-table-column
          label="创建时间">
          <template slot-scope="scope">
             <div>{{ formatime(scope.row.createDate) }}</div>
           </template>
        </el-table-column>
        <el-table-column
          prop="updateBy"
          label="更新人">
        </el-table-column>
        <el-table-column
          label="更新时间">
          <template slot-scope="scope">
             <div>{{ formatime(scope.row.updateDate) }}</div>
           </template>
        </el-table-column>
        <el-table-column
          label="操作选项">
           <template slot-scope="scope">
            <!-- <el-button
              size="mini"
              @click="handleEdit(1, scope.row)">编辑</el-button> -->
            <el-button
              size="mini"
              type="danger"
              v-if="queryByStatus === 1"
              @click="handleDelete(scope.$index, scope.row, 2)">删除</el-button>

            <el-button
              size="mini"
              type="success"
              v-if="queryByStatus === 2"
              @click="handleDelete(scope.$index, scope.row, 1)">恢复</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <div>
      <el-dialog
        :title="title"
        :visible.sync="centerDialogVisible"
        width="30%"
        center>
        <el-form :model="form">
          <el-form-item label="库位详细地址" :label-width="formLabelWidth">
            <el-input v-model="form.locationName"></el-input>
          </el-form-item>
           <el-form-item label="公司" :label-width="formLabelWidth">
            <el-select v-model="form.companyId" placeholder="请选择">
               <el-option
                v-for="item in companylist"
                :key="item.key"
                :label="item.chineseName ? item.chineseName : item.englishName"
                :value="item.id">
                <span style="float: left">{{ item.chineseName }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.englishName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handlesuccess(sts)">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { stocklocationfindAll, stocklocationadd, stocklocationupdateStatus, stockadd, findAll } from '../../api'
import utils from '../../../public/utils'
import qs from 'qs'
export default {
  data () {
    return {
      list: [],
      stockStatus: [ //  公司状态列表
        {
          value: 1,
          label: '有效'
        },
        {
          value: 2,
          label: '无效'
        }
      ],
      queryByStatus: 1, //  默认查询有效
      companylist: [], //  公司列表
      centerDialogVisible: false,
      form: { //  新增初始化form
      },
      formLabelWidth: '120px',
      sts: 0, //  0 添加, 1 编辑
      title: '' //  添加窗口标题
    }
  },
  methods: {
    handleChangeStatus () {
      this.getstocklocationfindAll(this.queryByStatus)
    },
    getcompanyfindAll (t, s) { //  公司列表
      let para = {
        typeId: t,
        status: s
      }
      findAll(para).then(data => {
        console.log(data.data.data)
        this.companylist = data.data.data
      })
    },
    handleEdit (ind, row) { //  编辑或者新增
      this.centerDialogVisible = true
      this.getcompanyfindAll(8, 1)
      console.log(ind, row)
      if (ind === 1) {
        this.title = '编辑仓储'
        this.form = row
        this.sts = 1
      } else {
        this.title = '新增仓储'
        this.form = {}
        this.sts = 0
      }
    },
    handlesuccess (sts) { //  提交修改信息
      if (sts === 0) {
        let para = new URLSearchParams(this.form)
        stocklocationadd(para).then(data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getstocklocationfindAll(this.queryByStatus)
            this.centerDialogVisible = false
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      } else {
        //  修改角色信息
      }
    },
    handleDelete (ind, row, sts) { //  删除
      this.$confirm('确定执行该操作吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then( () => {
        let para = new URLSearchParams()
        para.append('id', row.id)
        para.append('status', sts)
        stocklocationupdateStatus(para).then( data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getstocklocationfindAll(this.queryByStatus)
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      })
    },
    getstocklocationfindAll (s) { //  查询全部
      let params = {
        status: s
      }
      stocklocationfindAll(params).then(data => {
        console.log(data)
        this.list = data.data.data
      })
    },
    formatime (s) { //  格式化时间
      let a = utils.formatterTime(s)
      return a
    },
  },
  mounted () {
    this.getstocklocationfindAll(this.queryByStatus)
  }
}
</script>
<style lang="stylus" scoped>
.comond_btn
  display flex
  justify-content flex-end
  margin-bottom 30px
  button
    background-color #0a3d5f
    color #fff
</style>
